import { CardDetailsData } from "@/features/cards/types/CardDetails.type";
import Box from "@/common/components/Box";
import { formatCardNumber } from "@/common/utils/formatters";
import { cardTypeTranslation } from "@/common/constants/cards.constant";
import CardDetailFieldPair from "../CardDetailFieldPair";
import CardDetailCompanyInformation from "../CardDetailCompanyInformation";
import { equipmentFieldForDisplayTranslation } from "@/common/constants/equipmentFieldForDisplay.constant";
import type { CompanyData } from "@/features/companies/types/companies.type";
import { ClientCompanyBranchData } from "@/common/types/client/companyBranch.type";

type FleetCardDetailsProps = {
  cardDetails: CardDetailsData;
  companyData: CompanyData;
  clientBranch?: ClientCompanyBranchData;
}

const FleetCardDetails = ({ cardDetails, companyData, clientBranch }: FleetCardDetailsProps) => {
  return (
    <div className="flex flex-col gap-4">
      <CardDetailCompanyInformation
        companyData={companyData}
        companyBranch={cardDetails?.equipment?.branch}
      />

      <Box className="flex flex-col items-start rounded-lg gap-2 p-6 py-5">
        {!!clientBranch && (
          <CardDetailFieldPair
            label="Filial"
            value={clientBranch?.display_name || '--'}
          />
        )}

        <div className="flex gap-4 items-center">
          <p className="font-light italic">
            {
              equipmentFieldForDisplayTranslation[
              cardDetails?.equipment_field_for_display as keyof typeof equipmentFieldForDisplayTranslation
              ]
            }
            :
          </p>

          <p data-testid="license_plate_text" className="text-lg uppercase">
            {cardDetails?.equipment_field_for_display_value}
          </p>
        </div>

        <div className="bg-gray-disabled h-[2px] w-5 rounded" />

        <CardDetailFieldPair
          label="Cartão"
          value={formatCardNumber(cardDetails?.last_four_digits)}
        />

        <CardDetailFieldPair
          label="Tipo de Cartão"
          value={cardTypeTranslation[cardDetails?.type as keyof typeof cardTypeTranslation]}
        />

        <CardDetailFieldPair
          label="Modelo"
          value={cardDetails?.equipment?.model?.display_name}
        />
      </Box>
    </div>
  )
}

export default FleetCardDetails;
